import React, { useState, useRef, useEffect } from 'react';
import './Go.css'; // Reusing some styles

const itemTypes = [
  { name: 'Document', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> },
  { name: 'Small packages', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg> },
  { name: 'Groceries', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg> },
  { name: 'Clothing and apparels', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"></path></svg> },
  { name: 'Electronics', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line></svg> },
  { name: 'Gift and personalized item', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg> },
  { name: 'Fragile', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 22h8"></path><path d="M12 11v11"></path><path d="M18.32 7.68a5.09 5.09 0 0 0-1.04-2.58A5.09 5.09 0 0 0 14.69 4a5.09 5.09 0 0 0-2.58-1.04A5.09 5.09 0 0 0 9.32 4a5.09 5.09 0 0 0-2.59 1.04A5.09 5.09 0 0 0 4 7.68a5.09 5.09 0 0 0 1.04 2.58A5.09 5.09 0 0 0 7.68 11h8.64a5.09 5.09 0 0 0 2.58-1.04A5.09 5.09 0 0 0 20 7.68a5.09 5.09 0 0 0-1.04-2.58A5.09 5.09 0 0 0 18.32 7.68z"></path></svg> },
];

function PickupItemModal({ vehicle, onClose, onConfirm, pickup, dropoff, deliveryType, onDeliveryTypeChange }) {
  const [receiverName, setReceiverName] = useState('');
  const [receiverPhone, setReceiverPhone] = useState('');
  const [packageDescription, setPackageDescription] = useState('');
  const [itemType, setItemType] = useState(itemTypes[0]);
  const [pin, setPin] = useState('');
  const [isItemTypeDropdownOpen, setIsItemTypeDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleConfirm = () => {
    if (receiverName && receiverPhone && packageDescription && itemType && pin.length === 4) {
      onConfirm({
        receiverName,
        receiverPhone,
        packageDescription,
        itemType: itemType.name,
        pin,
      });
    } else {
      alert('Please fill in all fields, including a 4-digit PIN.');
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsItemTypeDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  if (!vehicle) return null;

  return (
    <div className="go-modal-overlay">
      <div className="go-modal">
        <div className="go-modal-header">
          <h2>Package Details for {vehicle.name}</h2>
          <button onClick={onClose} className="go-modal-close-btn" aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
        <div className="go-modal-body">
          <div className="go-modal-section">
            <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '12px' }}>Recipient Details</div>
            <input
              type="text"
              placeholder="Enter name here"
              value={receiverName}
              onChange={(e) => setReceiverName(e.target.value)}
              className="go-modal-input"
            />
            <div className="go-modal-phone-input-wrapper">
              <span className="go-modal-phone-prefix">+234</span>
              <input
                type="tel"
                placeholder="Enter phone number"
                value={receiverPhone}
                onChange={(e) => setReceiverPhone(e.target.value)}
                className="go-modal-input-inner"
              />
            </div>
          </div>
          <div className="go-modal-section">
            <h3 style={{ marginBottom: '16px' }}>Delivery Type</h3>
            <div className="delivery-type-options">
              <label className={`delivery-type-option ${deliveryType === 'instant' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="deliveryType"
                  value="instant"
                  checked={deliveryType === 'instant'}
                  onChange={(e) => onDeliveryTypeChange(e.target.value)}
                />
                <div className="delivery-type-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" fill="currentColor"></polygon></svg>
                </div>
                <div className="delivery-type-details">
                  <span className="delivery-type-title">Instant Priority</span>
                  <span className="delivery-type-subtitle">Delivery within 1 hour. Highest priority with fast pickup and dropoff.</span>
                </div>
                <div className="radio-check"></div>
              </label>
              <label className={`delivery-type-option ${deliveryType === 'express' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="deliveryType"
                  value="express"
                  checked={deliveryType === 'express'}
                  onChange={(e) => onDeliveryTypeChange(e.target.value)}
                />
                <div className="delivery-type-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 12.5L11 13V7h1.5v5.25l4.5 2.67-.75 1.23z" fill="currentColor"></path></svg>
                </div>
                <div className="delivery-type-details">
                  <span className="delivery-type-title">3 Hours Express</span>
                  <span className="delivery-type-subtitle">Delivery within 3 hours of booking.</span>
                </div>
                <div className="radio-check"></div>
              </label>
              <label className={`delivery-type-option ${deliveryType === 'same-day' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="deliveryType"
                  value="same-day"
                  checked={deliveryType === 'same-day'}
                  onChange={(e) => onDeliveryTypeChange(e.target.value)}
                />
                <div className="delivery-type-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24"><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z" fill="currentColor"></path></svg>
                </div>
                <div className="delivery-type-details">
                  <span className="delivery-type-title">Same Day</span>
                  <span className="delivery-type-subtitle">Delivery completed within the same day.</span>
                </div>
                <div className="radio-check"></div>
              </label>
            </div>
          </div>
          <div className="go-modal-section">
            <h3>Item Information</h3>
            <div className="item-type-dropdown" ref={dropdownRef}>
              <label className="go-modal-label">Type of item</label>
              <button className="item-type-dropdown-button" onClick={() => setIsItemTypeDropdownOpen(prev => !prev)}>
                <div className="item-type-icon">{itemType.icon}</div>
                <span className="item-type-name">{itemType.name}</span>
                <svg className="dropdown-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6"/></svg>
              </button>
              {isItemTypeDropdownOpen && (
                <ul className="item-type-dropdown-list">
                  {itemTypes.map(type => (
                    <li
                      key={type.name}
                      className="item-type-dropdown-item"
                      onClick={() => {
                        setItemType(type);
                        setIsItemTypeDropdownOpen(false);
                      }}
                    >
                      <div className="item-type-icon">{type.icon}</div>
                      <span className="item-type-name">{type.name}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div style={{marginTop: '24px'}}>
              <label className="go-modal-label">Item description</label>
              <textarea
                placeholder="Briefly describe the item (max 150 chars)"
                value={packageDescription}
                onChange={(e) => setPackageDescription(e.target.value)}
                className="go-modal-textarea"
                maxLength="150"
              />
            </div>
          </div>
          <div className="go-modal-section">
            <h3>Security</h3>
            <p style={{marginTop: '-8px', marginBottom: '16px'}}>Create a pin to confirm</p>
            <input
              type="tel"
              placeholder="Create a 4-digit PIN"
              value={pin}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value) && value.length <= 4) {
                  setPin(value);
                }
              }}
              className="go-modal-input go-modal-pin-input"
              maxLength="4"
              style={{ textAlign: 'center', letterSpacing: '0.5em', fontSize: '18px', fontWeight: 'bold' }}
            />
          </div>
        </div>
        <div className="go-modal-footer">
          <button onClick={handleConfirm} className="confirm-ride-btn" style={{width: '100%'}}>
            Continue {vehicle?.price ? `(${vehicle.price})` : ''}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PickupItemModal;